import React, { FunctionComponent, useCallback, useEffect, useMemo, useState } from 'react';

import styles from './nfl-predictions.module.scss';
import TeamPredictions from './team/team-predictions.component';
import { Button } from 'semantic-ui-react';
import GamePredictions from './game/game-predictions.component';
import { useMatch } from 'react-router-dom';
import { useHttpService } from 'src/shared/hooks/use-http-service';
import { NflPredictionsService } from 'src/shared/services/nfl-predictions.service';
import { ILatestUpdate } from 'src/shared/models/interfaces/ipredictions';

const tabs = ['standings', 'games'];

const NflPredictions: FunctionComponent = () => {
    const predictionsService = useHttpService(NflPredictionsService);
    const [active, setActive] = useState('standings');
    const match = useMatch('/predictions/nfl/:season');
    const [season, setSeason] = useState(2023);
    const [lastUpdate, setLastUpdate] = useState<ILatestUpdate>();

    const fetchLastUpdate = useCallback(async () => {
        const update = await predictionsService.getLatestUpdate(season);
        setLastUpdate(update);
    }, [season]);

    useEffect(() => {
        fetchLastUpdate();
    }, [fetchLastUpdate]);

    useEffect(() => {
        if (match?.params.season) setSeason(parseInt(match.params.season, 10));
    }, [match?.params.season]);

    const updateDate = useMemo(() => {
        const { last_update_ts } = lastUpdate ?? {};
        if (!last_update_ts) return '---';
        const lastUpdtDate = new Date(last_update_ts);
        return lastUpdtDate.toLocaleDateString('en-us', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    }, [lastUpdate?.last_update_ts]);

    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <h1>{`${season} NFL Predictions`}</h1>
                <h2>updated on {updateDate}</h2>
            </div>
            <div style={{ marginTop: 20, marginBottom: 10 }}>
                {tabs.map((tab) => (
                    <Button
                        key={tab}
                        className={tab === active ? styles.activeTab : styles.tab}
                        onClick={() => setActive(tab)}
                    >
                        {tab}
                    </Button>
                ))}
            </div>
            {active === 'standings' ? <TeamPredictions season={season} currentWeek={lastUpdate?.week} /> : null}
            {active === 'games' ? <GamePredictions season={season} week={lastUpdate?.week} /> : null}
        </div>
    );
};

export default NflPredictions;
